import { CloseButton, TextInput, type TextInputProps } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { SYSTEM_COLORS } from "@/configs/colorScheme";
import Icon from "@/utils/icons";

export interface FormFieldSearchProps extends Omit<TextInputProps, "onChange"> {
  onChange: (value: string) => void;
}

export const FormFieldSearch = ({ onChange, ...props }: FormFieldSearchProps) => {
  const { t } = useTranslation();
  return (
    <TextInput
      placeholder={t("search")}
      leftSection={<Icon.SEARCH />}
      rightSection={props.value ? <CloseButton variant="subtle" size="xs" onClick={() => onChange("")} /> : undefined}
      value={props.value}
      onChange={(e) => onChange(e.target.value)}
      styles={{
        label: {
          color: props.readOnly ? SYSTEM_COLORS.default : undefined,
        },
      }}
      {...props}
    />
  );
};

export default FormFieldSearch;
